import { queryLoginVerify } from './portalsLoginVerify';
export async function getPortalsLocaleInfo(config) {
  var _loginData$data;
  const searchParams = new URLSearchParams(window.location.search);
  const localeOverride = searchParams.get('localeOverride');
  if (localeOverride) {
    return {
      langEnabled: true,
      locale: localeOverride
    };
  }
  const loginData = await queryLoginVerify({
    client: config.client,
    objectId: config.objectId
  }).catch(e => {
    console.error('portalsLocaleInfo: loginVerify failed', e);
    return undefined;
  });
  const locale = (loginData === null || loginData === void 0 || (_loginData$data = loginData.data) === null || _loginData$data === void 0 || (_loginData$data = _loginData$data.result) === null || _loginData$data === void 0 ? void 0 : _loginData$data.preferredLanguage) || navigator.language;
  return {
    langEnabled: true,
    locale
  };
}